import {ReactNode, useContext, useEffect, useState} from "react";
import styled from "styled-components";
import Icon from "../Icon";
import Offcanvas from "react-bootstrap/Offcanvas";
import {ShowLoginContext} from "../../contexts/ShowLoginContext";
import {useRouter} from "next/router";
import baseTheme from "../../shared/baseTheme";
import {getTheme} from "../../shared/themeUtils";
import {ShouldChangeAddressContext} from "../../contexts/ShouldChangeAddressContext";

const IndicatorContainer = styled.div`
  display: flex;
  cursor: pointer;
  padding: 5px;
  position: relative;
  align-items: center;
  
  .indicator-text {
    font-weight: 500;
  }
  
  img.bordered-img {
    max-width: ${getTheme("space.3")};
      border: 1px solid ${getTheme("colors.border")};
  }
  
  .image-icon {
    width: 35px;
    margin-right: ${getTheme("space.1")};
  }
  
  .account-text {
    font-size: ${getTheme("fontSizes.small")};
    font-weight: 500;
  }
  
  .indicator-text {
    margin-left: 5px;
  }

  .cart-count {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: -8px;
    background-color: ${getTheme("colors.accent")};
      color: ${getTheme("colors.white")};
    width: 20px;
    height: 20px;
    font-size: 12px;
    border-radius: 50%;
    right: ${getTheme("space.1")};
  }
`

const CloseOffCanvas = styled.span`
  position: absolute;
  right: 15px;
  top: 13px;
  font-size: 20px;
  cursor: pointer;
  padding: 10px;
  z-index: 1;
  color: ${getTheme("colors.secondaryFont")};
  .close-icon > div {
    display: flex;
    align-items: center;
  }
`

type IndicatorProps = {
  value?: number;
  content?: ReactNode;
  icon?: string;
  iconVariant?: "small" | "xSmall" | "medium" | "large";
  borderedImg? : string;
  imgIcon?: string;
  img?: string;
  imgAlt?: string;
  text?: any;
  accountText?: string;
  url?: string;
  showLogin?: boolean;
  showContactsList?: boolean;
  itemCount?: number;
  placement?: "start" | "end" | "top" | "bottom";
  iconColor?: string;
  showTextInMobile?: boolean;
  backdrop?: string;
  keyboard?: boolean;
  disabled?: boolean;
}

const Indicator = (props: IndicatorProps) => {
  const {content, icon, iconVariant, text, url, showLogin, showContactsList, itemCount, placement, img, imgAlt,
    backdrop, keyboard, borderedImg, accountText} = props;
  const [show, setShow] = useState(false);
  const {setShowLoginContext} = useContext(ShowLoginContext);
  const {shouldChangeAddressCtx, setShouldChangeAddressCtx} = useContext(ShouldChangeAddressContext)
  const router = useRouter();

  useEffect(() => {
    router.events.on("routeChangeStart", () => handleClose());

    if (showLogin ) {
      setShow(showLogin);
    }

    if (showContactsList && shouldChangeAddressCtx) {
      setShow(showContactsList)
    }

    if (showContactsList!=undefined && showContactsList == false) {
      handleClose()
    }
  }, [props, shouldChangeAddressCtx])

  const handleClose = () => {
    setShow(false);
    if (showLogin) {
      setShowLoginContext(false)
    }
  }

  const handleShow = () => setShow(true);

  return (
    <>
      <IndicatorContainer onClick={handleShow}>
        {icon &&
          <Icon color={props.iconColor ? props.iconColor : baseTheme.colors.primary}
                variant={iconVariant}>{icon}</Icon>}
        {borderedImg && <img className="bordered-img" src={borderedImg} alt={imgAlt} />}
        {img && <img className={"image-icon"} src={img} alt={imgAlt} />}
        {text && <span className={props.showTextInMobile ? "indicator-text d-lg-block indicator-text" : "indicator-text d-none d-lg-block indicator-text"}>
          {text}
        </span>}
        {accountText && <span className={"account-text d-none d-lg-block"}>{accountText}</span>}
        {itemCount && itemCount > 0 ? <span className="cart-count">{itemCount}</span> : <></> }
      </IndicatorContainer>

      {!props.disabled && <Offcanvas show={show} onHide={handleClose} placement={placement} backdrop={backdrop} keyboard={keyboard}>
        <CloseOffCanvas onClick={handleClose}>
          <Icon variant={"medium"} className={"close-icon"}>close-line</Icon>
        </CloseOffCanvas>
        <Offcanvas.Body>
          {content}
        </Offcanvas.Body>
      </Offcanvas>}
    </>
  )
}

export default Indicator;
